/**
 * Combines multiple React refs into a single ref.
 * This may be used e.g. to attach both a forwarded ref and a local ref
 * to the same DOM element.
 *
 * @example
 * React.forwardRef((props, forwardedRef) => {
 * 	const ref = React.useRef();
 * 	return <div ref={combineRefs(ref, forwardedRef)} />;
 * });
 */
function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return value => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    }
  };
}

export { combineRefs };
